<template>
  <div>
	  <div class="page-bg">
			<div class="logo">
				<img src="../assets/logo.png" alt="" />
			</div>
				
	  		<div class="collect-page">
				<div class="title-bar fcc anim-title">
					<img src="../assets/slogen-page.png" alt="" />
				</div>
				<div class="class-list">
					<div class="class-item class-item1 anim-card" style="animation-delay:0.1s">
						<div class="icon fcc"><img src="../assets/1ban.png" alt="" /></div>
					</div>
					<div class="class-item class-item2 anim-card" style="animation-delay:0.2s">
						<div class="icon fcc"><img src="../assets/2ban.png" alt="" /></div>
					</div>
					<div class="class-item class-item1 anim-card" style="animation-delay:0.3s">
						<div class="icon fcc"><img src="../assets/3ban.png" alt="" /></div>
					</div>
					<div class="class-item class-item2 anim-card" style="animation-delay:0.4s">
						<div class="icon fcc"><img src="../assets/4ban.png" alt="" /></div>
					</div>
					<div class="class-item class-item1 anim-card" style="animation-delay:0.5s">
						<div class="icon fcc"><img src="../assets/5ban.png" alt="" /></div>
					</div>
					<!-- <div class="class-item class-item2 anim-card" style="animation-delay:0.6s">
						<div class="icon fcc"><img src="../assets/6ban.png" alt="" /></div>
					</div> -->
					
				</div>
			</div>
			
			<i-nav></i-nav>
	  </div>
	  
 


  </div>
</template>

<script>


export default {

  data() {
    return {
		uid: null
        
       
    };
  },
  async mounted() {
	this.uid = window.localStorage.getItem('cscec2026UserId')
    if(!this.uid){
			this.$router.push({path:'/'})
			return
		}
	

  },
  methods: {
    
    
  },
};
</script>
<style  scoped lang="less">
	.anim-title {
		animation: fadeUp 0.7s cubic-bezier(0.16, 1, 0.3, 1) both;
	}
	.anim-card {
		opacity: 0;
		animation: fadeUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) both;
	}
	@keyframes fadeUp {
		from {
			opacity: 0;
			transform: translateY(20px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
</style>

